import React from 'react';

const ExperienceEndingStructured = ({ content }) => {
  if (!content || !Array.isArray(content.days) || !content.days.length) {
    return null;
  }

  return (
    <div className="experience-ending-structured">
      {content.days.map((day, dayIndex) => (
        <div
          key={`day-${dayIndex}`}
          className={`experience-ending-structured__day experience-ending-structured__day--${dayIndex + 1}`}
        >
          {day.title && <h3 className="experience-ending-structured__day-title">{day.title}</h3>}

          {Array.isArray(day.sections) && day.sections.map((section, sectionIndex) => (
            <div
              key={`section-${dayIndex}-${sectionIndex}`}
              className={`experience-ending-structured__section experience-ending-structured__section--${sectionIndex + 1}`}
            >
              {section.title && <h4 className="experience-ending-structured__section-title">{section.title}</h4>}

              {Array.isArray(section.paragraphs) && section.paragraphs.map((paragraph, paragraphIndex) => (
                <p
                  key={`p-${dayIndex}-${sectionIndex}-${paragraphIndex}`}
                  className={`experience-ending-structured__paragraph experience-ending-structured__paragraph--${paragraphIndex + 1}`}
                >
                  {paragraph}
                </p>
              ))}

              {Array.isArray(section.bullets) && section.bullets.length > 0 && (
                <ul className="experience-ending-structured__section-bullets">
                  {section.bullets.map((bullet, bulletIndex) => (
                    <li
                      key={`b-${dayIndex}-${sectionIndex}-${bulletIndex}`}
                      className={`experience-ending-structured__section-bullet experience-ending-structured__section-bullet--${bulletIndex + 1}`}
                    >
                      {bullet}
                    </li>
                  ))}
                </ul>
              )}

              {section.note && <p className="experience-ending-structured__note">({section.note})</p>}
            </div>
          ))}

          {Array.isArray(day.bullets) && day.bullets.length > 0 && (
            <ul className="experience-ending-structured__day-bullets">
              {day.bullets.map((bullet, bulletIndex) => (
                <li
                  key={`day-b-${dayIndex}-${bulletIndex}`}
                  className={`experience-ending-structured__day-bullet experience-ending-structured__day-bullet--${bulletIndex + 1}`}
                >
                  {bullet}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default ExperienceEndingStructured;
